import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Voting.css";
import { getStoredAccessMode, isPremiumAccess } from "../../utils/accessMode";
import { SPECIAL_AWARD_DEFINITIONS } from "../../utils/awards";

const IntroduccionFinalVote = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accessMode = location.state?.accessMode || getStoredAccessMode();
  const isPremium = isPremiumAccess(accessMode) || Boolean(location.state?.isPremium);

  return (
    <div className="voting-shell intro-shell">
      <section className="intro-card">
        <p className="section-kicker">Premios especiales</p>
        <h1 className="VotingTitle">Llegan los reconocimientos que mas pesan en la gala.</h1>
        <p className="tofu-description">
          A partir de aqui ya no entran los premios de paso. Esta seccion reune los reconocimientos
          mas valiosos de la edicion: los que hablan de progreso real, impacto verdadero, nivel
          especial y capacidad para dejar huella de forma sostenida.
        </p>
        <p className="tofu-description secondary">
          Son premios mas dificiles de ganar, mas exigentes de votar y mas importantes por lo que
          representan dentro del grupo. Si estas en modo premium, la ponderacion especial ya esta
          aplicada tambien en estos podios.
        </p>

        <div className="special-awards-grid">
          {SPECIAL_AWARD_DEFINITIONS.map((award) => (
            <article key={award.key} className="special-award-card">
              <p className="section-kicker subtle">{award.name}</p>
              <p>{award.description}</p>
            </article>
          ))}
        </div>

        <div className="intro-actions">
          <button
            className="button-next-back"
            type="button"
            onClick={() => navigate("/voting", { state: { accessMode, isPremium } })}
          >
            Volver a categorias
          </button>
          <button
            className="button-voting"
            type="button"
            onClick={() => navigate("/special-awards", { state: { accessMode, isPremium } })}
          >
            Entrar en los premios especiales
          </button>
        </div>
      </section>
    </div>
  );
};

export default IntroduccionFinalVote;
